var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4382 6.06122L18.2627 8.89355M2.98566 21.5081C3.1116 20.6265 3.18178 19.7094 3.47594 18.8642C3.6454 18.3774 3.8769 17.9144 4.16472 17.4867C4.48907 17.0047 4.90885 16.5849 5.7484 15.7454L17.4097 4.08969C18.1908 3.30865 19.4571 3.30864 20.2381 4.08969C21.0192 4.87074 21.0192 6.13707 20.2381 6.91812L8.39729 18.7533C7.68593 19.4647 7.33025 19.8204 6.9274 20.1084C6.56976 20.3641 6.1851 20.5797 5.78035 20.7514C4.8965 21.1262 3.91693 21.2838 2.98566 21.5081Z",
    stroke: "#003B50",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.2dff3dcd58290a0583e94655f7712108.svg";
export { ForwardRef as ReactComponent };